import _toConsumableArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import React from "react";
var __jsx = React.createElement;
import { faPlus, faSpinner } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { UnstyledButton } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { trackEvent, ANALYTICS_EVENTS } from "@/utils/analytics";
/** AI-tag strip rendered below a collapsed report item header. Applied tags are shown first, un-applied tags last. */
export function ReportAiTags(_ref) {
  var tags = _ref.tags,
    title = _ref.title,
    onApplyTag = _ref.onApplyTag,
    applyingTagId = _ref.applyingTagId,
    className = _ref.className;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  if (!tags.length) return null;
  var orderedTags = _toConsumableArray(tags).sort(function (a, b) {
    return (b.applied ? 1 : 0) - (a.applied ? 1 : 0);
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "px-4 py-3 bg-sds-base-secondary border-t border-sds-base-default flex gap-2 flex-wrap items-center".concat(className ? " ".concat(className) : "")
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-style-label-caps text-sds-base-tertiary"
  }, title), orderedTags.map(function (tag) {
    var canApply = !!onApplyTag && tag.applied === false;
    var isApplying = applyingTagId === tag.id;
    return /*#__PURE__*/React.createElement(UnstyledButton, {
      key: tag.id,
      "data-testid": "report-ai-tag-".concat(tag.id),
      disabled: !canApply || isApplying,
      title: canApply ? t("label.apply_tag_to_patient", {
        defaultValue: "Apply tag to patient"
      }) : undefined,
      onClick: function onClick(e) {
        trackEvent(ANALYTICS_EVENTS.REPORT_AI_TAG, {
          tagId: tag.id
        });
        e.stopPropagation();
        if (canApply && !isApplying) onApplyTag === null || onApplyTag === void 0 || onApplyTag(tag);
      },
      className: ["rounded-sds-full px-3 py-1 text-style-label-emphasis select-none transition-all duration-200 inline-flex items-center gap-1", canApply ? "bg-teal-50 dark:bg-teal-900/30 border border-teal-300 dark:border-teal-700 text-teal-700 dark:text-teal-300 cursor-pointer hover:bg-teal-100/20 dark:hover:bg-teal-900 active:scale-95" : "bg-sds-base-secondary border border-sds-base-default text-sds-base-secondary cursor-default", isApplying ? "opacity-60 cursor-wait" : ""].filter(Boolean).join(" ")
    }, canApply && /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: isApplying ? faSpinner : faPlus,
      className: "w-2.5 h-2.5".concat(isApplying ? " animate-spin" : "")
    }), tag.label);
  }));
}